import { jsx as _jsx } from "react/jsx-runtime";
export const PersonXs = ({ color, ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M11 8.25C11.9665 8.25 12.75 9.0335 12.75 10V14C12.75 14.4142 12.4142 14.75 12 14.75H4C3.58579 14.75 3.25 14.4142 3.25 14V10C3.25 9.0335 4.0335 8.25 5 8.25H11ZM5 9.75C4.86193 9.75 4.75 9.86193 4.75 10V13.25H11.25V10C11.25 9.86193 11.1381 9.75 11 9.75H5ZM8 0.25C9.79493 0.25 11.25 1.70507 11.25 3.5C11.25 5.29493 9.79493 6.75 8 6.75C6.20507 6.75 4.75 5.29493 4.75 3.5C4.75 1.70507 6.20507 0.25 8 0.25ZM8 1.75C7.0335 1.75 6.25 2.5335 6.25 3.5C6.25 4.4665 7.0335 5.25 8 5.25C8.9665 5.25 9.75 4.4665 9.75 3.5C9.75 2.5335 8.9665 1.75 8 1.75Z",
            fill: color ?? 'currentColor'
        })
    });

//# sourceMappingURL=person-xs.js.map